import React from 'react'
import ResourceCard from '../utils/ResourceCard'
import PageHero from '../utils/PageHero'
import Reveal from '../utils/Reveal'
import resources from '../data/resources.json'

const resolveImg = (img) =>
  img && (img.startsWith('http://') || img.startsWith('https://'))
    ? img
    : require(`../resources/${img.replace('../resources/', '')}`)

const ResourcesScreen = () => {
  return (
    <div>
      <PageHero
        eyebrow='Infrastructure'
        title='Lab Resources'
        description='The compute and hardware that power our research, from AI workstations to GPU clusters.'
      />
      <div className='container-wide page-body'>
        <div className='resource-grid'>
          {resources.map((record, i) => (
            <Reveal key={record.id} delay={(i % 4) * 0.05}>
              <ResourceCard name={record.name} img={resolveImg(record.img)} />
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ResourcesScreen
